import React from 'react';
import { s } from '../Style.jsx';

const OrderNotes = ({ order }) => {

    if (!order?.notes)
        return <></>;

    return <>

        <h3 style={{ marginBottom: 10 }}>Instructions</h3>
        <span style={{ fontSize: 14, backgroundColor: "#fff", display: "block", marginBottom: 10 }}>{order?.notes}</span>

    </>;
}

export default OrderNotes;